import './new-converge-input-label.scss';

import {
  IconButton,
  InputLabel,
  InputLabelProps,
  Tooltip,
} from '@mui/material';

import InfoOutlineIcon from '@mui/icons-material/InfoOutlined';
import { ReactNode } from 'react';

interface INewConvergeInputLabelProps extends InputLabelProps {
  label: ReactNode;
  required?: boolean;
  tooltip?: ReactNode;
}

export const NewConvergeInputLabel = ({
  label,
  required,
  sx,
  className,
  tooltip,
  ...props
}: INewConvergeInputLabelProps) => {
  return (
    <>
      <InputLabel
        className={`new-coverage-input-label ${className}`}
        sx={{ ...sx }}
        {...props}
      >
        {label}
        {required ? <span className="required"> (REQD)</span> : null}
        {tooltip && (
          <Tooltip
            title={tooltip}
            arrow
            placement="top"
            leaveDelay={300}
            componentsProps={{
              tooltip: {
                sx: {
                  width: '200px', // Fixed width container
                  display: 'flex',
                  alignItems: 'center', // Vertical centering
                  justifyContent: 'center', // Horizontal centering
                  backgroundColor: '#333333',
                  borderRadius: '3px',
                  color: 'white',
                  fontSize: '12px',
                  fontWeight: '600',
                  padding: '10px',
                  margin: '0 auto', // Center the container itself
                },
              },
              arrow: {
                sx: {
                  color: '#333333',
                },
              },
            }}
          >
            <IconButton style={{}} size="small">
              <InfoOutlineIcon fontSize={'medium'} />
            </IconButton>
          </Tooltip>
        )}
      </InputLabel>
    </>
  );
};
